import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import translationEN from './assets/translations/en.json';
import translationRU from './assets/translations/ru.json';
import translationKA from './assets/translations/ka.json';

i18n.use(initReactI18next).init({
  resources: {
    en: { translation: translationEN },
    ru: { translation: translationRU },
    ka: { translation: translationKA },
  },
  lng: 'en',
  fallbackLng: 'en',
  interpolation: {
    escapeValue: false,
  },
});

export default i18n;
